import {
    UPDATE_USER_START,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAIL,
} from './ActionsTypes';
// alerts
import Swal from 'sweetalert2';
// axios
import clienteAxios from '../../config/Axios';

export function UpdateUser(data, navigate, token, setFormData, id) {
    return (dispatch) => {
        dispatch(UpdateUserStart())

        const config = { headers: { 'Authorization': "Bearer " + token } };//confi axios

        clienteAxios.put(`/api/users/update-user/${id}`, data, config)
            .then((res) => {
                // console.log(res.data)
                Swal.fire({ icon: 'success', title: 'Exito', text: 'Usuario actualizado' })
                dispatch(UpdateUserSuccess())
                setFormData({
                    firstname: "",
                    lastname: "",
                    dni: "",
                    creditIDId: "",
                    phone: "",
                    password: "",
                    confirmPassword: "",
                    isActive: false
                })
                navigate('/usuarios')
            })
            .catch(error => {
                dispatch(UpdateUserFail())
                console.log(error.response)
                if (!error.response) {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Error de conexión.' })
                } else if (error.response.status === 400) {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Datos invalidos' })
                } else {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Error, intente de nuevo' })
                }
            })
    }
}



export const UpdateUserStart = () => {
    return {
        type: UPDATE_USER_START
    };
};

export const UpdateUserSuccess = () => ({
    type: UPDATE_USER_SUCCESS
})

export const UpdateUserFail = () => ({
    type: UPDATE_USER_FAIL,
})
